export default __webpack_public_path__ + "static/media/tinyDaoLeft.d810d9df.png";